import { CaseTalkCTA } from "./CaseTalkCTA";
import { CaseNextLink } from "./CaseNextLink";
import { CaseMiniFooter } from "./CaseMiniFooter";

export const CaseFooter = ({ campaign, next }) => {
  return (
    <>
      <section className="hairline-b border-b">
        <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-24 grid grid-cols-12 gap-8 md:gap-12">
          <CaseTalkCTA campaign={campaign} />
          <CaseNextLink next={next} />
        </div>
      </section>
      <CaseMiniFooter />
    </>
  );
};
